import { Injectable } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { ReviewVrboGuestDialogComponent } from './review-vrbo-guest-dialog.component'

@Injectable()
export class ReviewVrboGuestDialogService {
  constructor(private dialog: DialogService) {}

  open(inquiry: Inquiry) {
    return this.dialog
      .openDrawer(ReviewVrboGuestDialogComponent, {
        data: { inquiry },
      })
      .afterClosed()
  }
}
